import { render, staticRenderFns } from "./selectTab.vue?vue&type=template&id=42f47700&scoped=true"
import script from "./selectTab.vue?vue&type=script&lang=js"
export * from "./selectTab.vue?vue&type=script&lang=js"
import style0 from "./selectTab.vue?vue&type=style&index=0&id=42f47700&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "42f47700",
  null
  
)

export default component.exports